import { gql } from '@apollo/client';
const LOAD_ONE_SPECIFICATION_DATA = gql `
  mutation LoadOneSpecificationData {
    loadOneSpecificationData
  }
`;
export default LOAD_ONE_SPECIFICATION_DATA;
